import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/swiper-bundle.css";

const testimonials = [
  {
    name: "Anita Saini",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "Shankar IAS Academy offers a strong and structured education with highly relevant study materials, especially in History, Polity, and International Relations. Adding weekly debates, quizzes, and regular current affairs sessions would further enhance learning. Weekly tests for prelims and mains could also improve exam preparedness. Overall, the academy provides quality education and a valuable learning experience.",
  },
  {
    name: "Ritika",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "I give Shankar IAS Academy a 5-star rating for its supportive environment and dedicated faculty. The teaching staff and management genuinely care about students, fostering a strong teacher-student connection. Despite resource challenges, the faculty remained enthusiastic, delivering top-notch content in interactive classes. The academy feels like a family, not just a coaching institute, truly invested in students' success. Thank you for the unwavering support!",
  },
  {
    name: "Avinash Singh",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "I sincerely appreciate Shankar IAS Academy's exceptional guidance and support. The expert faculty, well-structured courses, and high-quality study materials have greatly enhanced my UPSC preparation. Regular test series, doubt-clearing sessions, and Mains answer writing practice made learning effective and boosted my confidence. Thank you for your dedication to student success!",
  },
  {
    name: "Nikita Singh",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "I sincerely appreciate the guidance and support from S.I.A. The teachers are supportive, and the study material is of good quality. However, some materials are pending, and I request their prompt delivery. Regular test series for the Preliminary exam would also help improve preparation and assessment.",
  },

  {
    name: "Aditya Katach",
    position: "Himachal Pradesh University, Shimla",
    quote:
      "Studying at Shankar IAS Academy was a great experience. The faculty's efforts ensured a clear understanding of every subject, making learning smooth and effective. I truly appreciate the quality education provided and am grateful to the academy for bringing it to HP.",
  },
];

const Testimonial = () => {
  return (
    <div>
    <h3 className="text-center text-3xl font-bold mb-6">Student Testimonial</h3>
    <div className="row d-flex align-items-stretch">
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={30}
      slidesPerView={3}
      loop={true}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000 }}
      breakpoints={{
        320: { slidesPerView: 1 },  // Mobile
        640: { slidesPerView: 2 },  // Small tablets
        1024: { slidesPerView: 3 }, // Laptops
        1280: { slidesPerView: 3 }, // Large screens
      }}
      className="p-4"
    >
     
      {testimonials.map((testimonial, index) => (

        <SwiperSlide key={index} className="col-12 col-md-4 bg-white shadow-lg border rounded-xl mb-6">
          <div className="p-6 p-4">
            <p style={{'height':'250px'}}><small><i className="bi bi-quote fs-2 text-primary"></i>{testimonial.quote}</small></p>
            <h5 className="text-lg mt-4 text-danger"><small>{testimonial.name}</small></h5>
            <p className="text-gray-500">{testimonial.position}</p>
          </div>
        </SwiperSlide>
      ))}
     
    </Swiper>
    </div>
      <style jsx global>{`

          #support{
      position: relative;
    }
    #support::before {
         position: absolute;
    content: "";
    width: 8%;
    border-bottom: 2px solid red;
    bottom: 18px;
    margin: -1px 64px;
    }

  
        .sectiontitle {
           font-family: Switzer-Bold;
            font-size: 28px;
            line-height: 48px;
            letter-spacing: 0px;
        }
        .swiper-button-prev,
        .swiper-button-next {
          width: 35px;
          height: 35px;
          background-color: white;
          border-radius: 50%;
          box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2);
          color: #d83a56;
          transition: all 0.3s ease;
        }

        .swiper-button-prev::after,
        .swiper-button-next::after {
          font-size: 16px;
          font-weight: bold;
        }

        .swiper-button-prev:hover,
        .swiper-button-next:hover {
          transform: scale(1.1) rotateY(10deg);
          background-color: #ffe6e6;
          color: #b02a37;
        }
      `}</style>
  </div>
  );
};

export default Testimonial;
